import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Pagination, Radio, Stack, Switch, TextField, Grow, Grid, FormGroup, Checkbox } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToDoctor, goToLogin, goToTypes, goToUsers } from "../../../routes/Coordinator";
import axios from "axios";
import { useEffect } from "react";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const natures = [
  {
    value: "inflow",
    label: "Receita",
  },
  {
    value: "outflow",
    label: "Despesa",
  },
];
const options = [
  {
    value: "cashbook",
    label: "Livro caixa",
  },
  {
    value: "income_tax",
    label: "Imposto de renda",
  },
  {
    value: "cash_outflow",
    label: "Despesa Fluxo de Caixa",
  },
];

function UseQuery() {
  return new URLSearchParams(window.location.search)
}

const TypeRecord = () => {

  const [name, setName] = useState("")
  const [nature, setNature] = useState("")
  const [option, setOption] = useState("")
  const [roles, setRoles] = useState([])
  const [checkedManager, setCheckedManager] = useState(false);
  const [checkedTechnician, setCheckedTechnician] = useState(false);
  const [checkedCounter, setCheckedCounter] = useState(false);
  const navigate = useNavigate();


  function checkValue(e) {
    if (e.target.checked) {
      setRoles([...roles, e.target.value])
      if (e.target.value === "manager") {
        setCheckedManager(true)
      }
      if (e.target.value === "technician") {
        setCheckedTechnician(true)
      }
      if (e.target.value === "counter") {
        setCheckedCounter(true)
      }
    } else {
      const rolereturn = { manager: 'Gerencial', technician: 'Técnico', counter: 'Contador' }
      const index = roles.indexOf(rolereturn[e.target.value])
      let newArray = roles
      newArray.splice(index, 1)
      e.target.checked = false
      setRoles(newArray)
      if (e.target.value === "manager") {
        setCheckedManager(false)
      }
      if (e.target.value === "technician") {
        setCheckedTechnician(false)
      }
      if (e.target.value === "counter") {
        setCheckedCounter(false)
      }
    }
  }
  const save = () => {
    let id = UseQuery().get("id")

    if (!id) {
      newType()
    } else {
      EditType()
    }
  }
  const newType = () => {
    axios.post(`${process.env.REACT_APP_BASE_URL}/types`, { type: { name, nature, option, roles: roles.join() } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"

        }
      })

      .then((response) => {
        alert("Tipo cadastrado com sucesso!")
        goToTypes(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )

  }
  const EditType = () => {

    let id = UseQuery().get("id")
    let url = `${process.env.REACT_APP_BASE_URL}/types/${id}`
    axios.put(url, { type: { name, nature, option, roles: roles.join() } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        goToTypes(navigate)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const Show = () => {
    let id = UseQuery().get("id")
    if (id) {
      let url = `${process.env.REACT_APP_BASE_URL}/types/${id}`

      axios.get(url,
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "expiry": localStorage.getItem("expiry"),
            "token-type": localStorage.getItem("token-type"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          setName(response.data.name)
          setOption(response.data.option)

          const optionreturn = { 'Livro Caixa': 'cashbook', 'Imposto de Renda': 'income_tax', 'Despesa Fluxo de Caixa': 'cash_outflow' }
          setOption(optionreturn[response.data.option])

          const naturereturn = { 'Receita': 'inflow', 'Despesa': 'outflow' }
          setNature(naturereturn[response.data.nature])
          const rolereturn = { 'Gerencial': 'manager', 'Técnico': 'technician', 'Contador': 'counter' }
          let translatedRoles = []
          response.data.roles.split(", ").forEach(element => {
            translatedRoles.push(rolereturn[element])
          });
          setRoles(translatedRoles)
          if (response.data.roles.split(", ").includes("Gerencial")) {
            setCheckedManager(true)
          }
          if (response.data.roles.split(", ").includes("Técnico")) {
            setCheckedTechnician(true)
          }
          if (response.data.roles.split(", ").includes("Contador")) {
            setCheckedCounter(true)
          }
        })
        .catch(erro => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
          if (erro.response.status === 401) {
            goToLogin(navigate)
          }
        })
    }
  }

  useEffect(() => {
    Show()

  }, [])
  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Cadastrar Tipo</Typography>
          <Divider />
          <form>
            <Typography sx={{ paddingTop: 1 }} variant="h3">Dados</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    required
                    id="outlined-required"
                    label="Nome"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    name={"name"}
                    type={"name"}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                  <TextField
                    fullWidth
                    select
                    label="Tipo"
                    required
                    id="function"
                    onChange={(e) => setNature(e.target.value)}
                    value={nature}
                    name={"nature"}
                    type={"nature"}
                  >
                    {natures.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                  <TextField
                    fullWidth
                    select
                    required
                    label="Opção"
                    id="function"
                    onChange={(e) => setOption(e.target.value)}
                    value={option}
                    name={"option"}
                    type={"option"}
                  >
                    {options.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

              </Grid>
            </CardContent>
            <Typography variant="h3">Perfil</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <FormGroup
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                    required
                    id="function"
                    onChange={(e) => checkValue(e)}
                    value={roles}
                    name={"roles"}
                    type={"roles"}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                          checked={checkedManager}
                          value={"manager"}
                        />
                      }
                      label="Gerencial"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                          checked={checkedTechnician}
                          value={"technician"}
                        />
                      }
                      label="Técnico"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<CheckBoxOutlineBlankIcon />}
                          checkedIcon={<CheckBoxIcon />}
                          checked={checkedCounter}
                          value={"counter"}
                        />
                      }
                      label="Contador"
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Box>
                <Button onClick={save} variant="contained" color="success" startIcon={<AddIcon />}>
                  Salvar
                </Button>
                <Button onClick={() => goToTypes(navigate)} variant="outlined" startIcon={<ArrowBackIosIcon />}>
                  Voltar
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TypeRecord;